import { Link } from "react-router-dom";
import { ShoppingBag, X, ArrowRight } from "lucide-react";
import CartItems from "./CartItems";
import { useCart } from "../../context/CartContext";
import { Offcanvas } from "react-bootstrap";

function CartCanvas() {
  const { cartItems, cartSummary } = useCart();

  const hasItems = cartItems && cartItems.length > 0;

  return (
    <>
      <Offcanvas.Header className="custom-cart-header">
        <Offcanvas.Title as="div" className="custom-cart-title">
          <ShoppingBag size={20} />
          <span>Your Bag</span>
          {hasItems && (
            <span className="custom-cart-count">{cartItems.length}</span>
          )}
        </Offcanvas.Title>

        <button
          type="button"
          className="custom-cart-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close cart"
        >
          <X size={18} />
        </button>
      </Offcanvas.Header>

      <Offcanvas.Body className="custom-cart-items overflow-hidden d-flex flex-column">
        {hasItems ? (
          <>
            {/* Items list (scrollable) */}
            <div className="custom-cart-list">
              {cartItems.map((item, index) => (
                <CartItems key={item._id || index} item={item} />
              ))}
            </div>

            {/* Footer (fixed at bottom) */}
            <div className="custom-cart-footer">
              <div className="custom-cart-total-row">
                <span className="custom-cart-subtotal-label">Total</span>
                <span className="custom-cart-subtotal-value">
                  ₹{cartSummary?.total}
                </span>
              </div>
              <small className="custom-cart-note">
                Shipping & taxes checkout pe calculate honge.
              </small>

              <Link
                to="/cart"
                className="custom-cart-btn-view"
                data-bs-dismiss="offcanvas"
              >
                Go to cart <ArrowRight size={16} />
              </Link>

              <Link
                to="/shop"
                className="custom-cart-btn-continue"
                data-bs-dismiss="offcanvas"
              >
                Continue shopping
              </Link>
            </div>
          </>
        ) : (
          <div className="custom-cart-empty">
            <div className="custom-cart-empty-icon">
              <ShoppingBag size={34} strokeWidth={1.5} />
            </div>
            <h6>Your bag is empty</h6>
            <p>Looks like you haven't added anything yet.</p>
            <Link
              to="/shop"
              className="custom-cart-btn-view"
              data-bs-dismiss="offcanvas"
            >
              Shop now <ArrowRight size={16} />
            </Link>
          </div>
        )}
      </Offcanvas.Body>
    </>
  );
}

export default CartCanvas;